"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getOptions = getOptions;
exports.isKnownValue = isKnownValue;
const api_1 = require("../utils/api");
const maxCacheAge = 5 * 60 * 1000; // 5 minutes
const cache = {};
async function getOptions(path, search, internal) {
    let url = internal ? `/options/internal/${path}` : `/options/${path}`;
    if (search !== undefined) {
        if (url.includes("?")) {
            url += `&${search}`;
        }
        else {
            url += `?${search}`;
        }
    }
    if (!(url in cache) || Date.now() - cache[url].timestamp > maxCacheAge) {
        const { data: options } = await api_1.api.get(url);
        cache[url] = { timestamp: Date.now(), options };
    }
    return cache[url].options;
}
function isKnownValue(options, value) {
    return options.some(option => option.value === value);
}
